export function hasFilters(state) {
  return Object.entries(state.appliedFilters).length > 0;
}

export function hasJumboFilters(state) {
  return Object.entries(Object.keys(state.appliedFilters).filter(filter => filter !== 'schoolName')).length > 0;
}

export function stateAbbreviations(state) {
  let states = {};

  if (!state.filterOptions?.location) return states;

  Object.values(state.filterOptions.location.regions).forEach(s => {
    s.forEach(({ state, abbreviation }) => states[state] = abbreviation);
  });

  return states;
}
